module.exports = __webpack_public_path__ + "media/images/gallery/constellations/dir_layer_on-765766a919e9a48fa26ed2e36c137c93.jpg";